import { cn } from "@repo/design-system/utils";
import type { ButtonHTMLAttributes } from "react";

/**
 * The look of an inline text action in the drawer: the interactive foreground
 * colour, underlined on hover, with the drawer's focus ring. Exported for the
 * rare action that is a real link (`<Link>`) rather than a button, so it still
 * reads the same.
 */
export const LINK_BUTTON_CLASS =
  "text-ui-fg-interactive focus-visible:shadow-borders-focus flex w-fit items-center gap-x-1 rounded-sm text-sm font-medium underline-offset-2 hover:underline focus-visible:outline-none";

/**
 * An inline text action in the drawer ("Try again", "Sign in", "Dismiss"): a
 * real `button` that reads as a link. The one place the interactive-foreground
 * link look is written, so the drawer's actions cannot drift apart.
 */
export function LinkButton({
  className,
  type = "button",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      className={cn(LINK_BUTTON_CLASS, className)}
      {...props}
    />
  );
}
